import { render } from "./CompanyChat.vue?vue&type=template&id=50ae7982&scoped=true"
import script from "./CompanyChat.vue?vue&type=script&lang=js"
export * from "./CompanyChat.vue?vue&type=script&lang=js"

import "./CompanyChat.vue?vue&type=style&index=0&id=50ae7982&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ae7982"]])

export default __exports__